module.exports = __webpack_public_path__ + "img/sample_logo.2df27313.png";